export var findPostitoimipaikka = function (postinumero, postinumerot, language) {
    var _a;
    var postinumeroUri = "posti_".concat(postinumero);
    return (_a = postinumerot.find(function (p) { return p.uri === postinumeroUri; })) === null || _a === void 0 ? void 0 : _a.nimi[language];
};
